import React from 'react';
import { useFeatureFlags } from '@/contexts/FeatureFlagsContext';
import { Lock } from 'lucide-react';

export function FeatureGate({ flagKey, featureName, children }) {
  const { isEnabled, loading } = useFeatureFlags();

  if (loading) return null;

  if (!isEnabled(flagKey)) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center" data-testid={`feature-locked-${flagKey}`}>
        <div className="p-4 bg-slate-100 dark:bg-slate-800 rounded-full mb-4">
          <Lock className="h-8 w-8 text-slate-400" />
        </div>
        <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
          {featureName || 'Feature'} is not available
        </h2>
        <p className="text-sm text-slate-500 dark:text-slate-400 max-w-md">
          This feature is not enabled for your organization. Contact your administrator to request access.
        </p>
      </div>
    );
  }

  return children;
}
